module.exports = __webpack_public_path__ + "static/img/IMG_20241208_165015.9fda1431.jpg";